import { render, staticRenderFns } from "./OrganizationModal.vue?vue&type=template&id=6267c454&scoped=true&"
import script from "./OrganizationModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationModal.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationModal.vue?vue&type=style&index=0&id=6267c454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6267c454",
  null
  
)

export default component.exports